import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ protocol, finished, order }) => (
    <div className="header bg-gradient-danger py-6">
        <div className="container-fluid">
            <div className="header-body">
                <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-5">
                        <h6 className="h2 text-white d-inline-block mb-0">Repasse</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Details/Header.js